/*
 * @Author: tangke
 * @Date: 2019-02-16 17:57:17
 * @Last Modified by: others
 * @Last Modified time: 2019-02-27 15:37:27
 * 导航栏个人信息面板下Integral Level的弹窗
 */
 <template>
  <v-dialog v-model="levelData.dialog"
            width="600">
    <v-card class="blue-title">
      <v-card-title class="headline text-xs-center font-weight-bold blue-title"
                    primary-title>
        <v-spacer></v-spacer>
        Grade Integral
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers"
                      :items="desserts"
                      hide-actions
                      class="common-table">
          <template slot="items"
                    slot-scope="props">
                    <tr>
                      <td class="blue-title-2 font-weight-bold">{{ props.item.level }}</td>
                      <td class="text-xs-right blue-title">{{ props.item.range }}</td>
                      <td class="blue-title-2 font-weight-bold">{{ props.item.level2 }}</td>
                      <td class="text-xs-right blue-title">{{ props.item.range2 }}</td>
                    </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getGradeintegral } from '@/api/tutordata'
export default {
  name: 'level',
  props: {
    levelData: {
      dialog: false
    }
  },
  data: () => ({
    headers: [
      {
        text: 'Level',
        align: 'left',
        sortable: false,
        value: 'level'
      },
      {
        text: 'Range',
        align: 'right',
        sortable: false,
        value: 'range'
      },
      {
        text: 'Level',
        align: 'left',
        sortable: false,
        value: 'level2'
      },
      {
        text: 'Range',
        align: 'right',
        sortable: false,
        value: 'range2'
      }
    ],

    desserts: [],
    dessertsTwo: []
  }),
  mounted () {
    getGradeintegral().then(res => {
      if (res.data.ErrorCode === 0) {
        var score = this.$store.state.user.teachingPoints
        var currScore = res.data.Body.filter(t => t.ScoreStart <= score && t.ScoreEnd >= score)
        if (!!currScore && currScore.length > 0) {
          this.$store.dispatch('SetIntegralLevel', currScore[0].GradeName)
        }
        this.dessertsTwo = res.data.Body.slice(Math.ceil(res.data.Body.length / 2)).map(t => {
          return {
            level: t.GradeName,
            range: t.ScoreStart + '-' + t.ScoreEnd
          }
        })
        this.desserts = res.data.Body.slice(0, Math.ceil(res.data.Body.length / 2)).map((t,i) => {
          return {
            level: t.GradeName,
            range: t.ScoreStart + '-' + t.ScoreEnd,
            level2: this.dessertsTwo[i].level,
            range2: this.dessertsTwo[i].range
          }
        })
      }
    })
  },
  methods: {
    show () {
      this.levelData.dialog = true
    }
  }
}
</script>
